document.addEventListener("DOMContentLoaded", function() {


  const navItems = document.querySelectorAll(".header__nav-item.js-nav-item.has-dropdown");
  let timeout;

  navItems.forEach(item => {
    item.addEventListener("mouseenter", function() {
      clearTimeout(timeout);
      const dropdown = item.querySelector(".header__nav-dropdown");

      //clos all dropdowns
      const dropdowns = document.querySelectorAll('.header__nav-dropdown.js-dropdown');
      dropdowns.forEach((dropdown) => {
        dropdown.style.visibility = "hidden";
        dropdown.style.opacity = "0";
        dropdown.style.pointerEvents = "none";

        // document.querySelector('.js-header').classList.remove('is-scrolled');
      }
      );


      if (dropdown) {
        dropdown.style.visibility = "visible";
        dropdown.style.opacity = "1";
        dropdown.style.pointerEvents = "auto";    
        
        document.querySelector('.js-header').classList.add('is-scrolled');
      }
    });

    item.addEventListener("mouseleave", function() {
      const dropdown = item.querySelector(".header__nav-dropdown");
      if (dropdown) {
        timeout = setTimeout(() => {
          dropdown.style.visibility = "hidden";
          dropdown.style.opacity = "0";
          dropdown.style.pointerEvents = "none";
          // document.querySelector('.js-header').classList.remove('is-scrolled');
        }, 300); // Adjust delay as needed
      }
    });

    const dropdown = item.querySelector(".header__nav-dropdown");
    if (dropdown) {
      dropdown.addEventListener("mouseenter", function() {
        clearTimeout(timeout);
      });

      dropdown.addEventListener("mouseleave", function() {
        timeout = setTimeout(() => {
          dropdown.style.visibility = "hidden";
          dropdown.style.opacity = "0";
          dropdown.style.pointerEvents = "none";
          // document.querySelector('.js-header').classList.remove('is-scrolled');
        }, 300); // Adjust delay as needed
      });
    }
  });
});







document.addEventListener('DOMContentLoaded', function() {

  const mmSliderChangers = document.querySelectorAll('.js-slider-changer');
  const mmSliderWraps = document.querySelectorAll('.custom-third-menu__container');


  // on scroll down closs all dropdowns

  window.addEventListener('scroll', function() {
    const dropdowns = document.querySelectorAll('.custom-third-menu__container');

    // document.querySelector('.header__nav-dropdown.js-dropdown').style.visibility = 'hidden';

  })


  mmSliderChangers.forEach((changer) => {
    changer.addEventListener('mouseenter', function(e) {

      e.preventDefault();
      const ref = changer.getAttribute('data-parent');

  
      mmSliderChangers.forEach((changer) => {
        changer.classList.remove('active');
      });
  
      changer.classList.add('active');
  
      mmSliderWraps.forEach((wrap) => {
        wrap.classList.remove('active');
      });
  
      mmSliderWraps.forEach((wrap) => {
        const wrapRef = wrap.getAttribute('data-parent');
  
        if (wrapRef === ref) {
          wrap.classList.add('active');
        }
      });
    });
  });





  const swipers = document.querySelectorAll('.swiper-mm');



  swipers.forEach((swiperWrap) => {
    const sliderType = swiperWrap.getAttribute('data-section');

    let pagination = swiperWrap.querySelector('.swiper-pagination');



    switch (sliderType) {
  
      default:



      // const scrollBar = swiperWrap.parentNode.querySelector('.swiper-scrollbar');
      const swiperButtonNext = swiperWrap.parentNode.querySelector('.swiper-button-next');
      const swiperButtonPrev = swiperWrap.parentNode.querySelector('.swiper-button-prev');






      const swiper = new Swiper(swiperWrap, {
        // Optional parameters
        slidesPerView: 4,
        loop: false,
        spaceBetween: 20,
        // mousewheel: {
        //   forceToAxis: true, // Swiping is constrained to the axis, allowing natural scroll behavior
        // },
    
        breakpoints: {
          0: {
            slidesPerView: 1.5,
    
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1224: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      
        // // If we need pagination
        // pagination: {
        //   el: '.swiper-pagination',
        // },
      
        // Navigation arrows
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev,
        },
      
        // // And if we need scrollbar
        // scrollbar: {
        //   el: scrollBar,
        // },
      });





    }
  })


  



//  const dis_inputs = document.querySelectorAll(".discount_coupen");
 const isIphone = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (isIphone) {
document.addEventListener("focusin", function(e) {
  if (e.target.classList.contains("discount_coupen")) {
    e.target.parentElement.classList.add("discount_active");
    document.querySelector(".cart-drawer__inner")?.classList.add("cart-discount-active");
  }
});

document.addEventListener("focusout", function(e) {
  if (e.target.classList.contains("discount_coupen")) {
    e.target.parentElement.classList.remove("discount_active");
    document.querySelector(".cart-drawer__inner")?.classList.remove("cart-discount-active");
  }
});
    }

})

